import get from 'lodash/get';

/**
 * True if a feature flag is enabled.
 * Note: Using this selector directly is not recommended. Consider using
 * `withFeatureFlags` hoc instead.
 *
 * @param {Object} state The Redux state.
 * @returns {boolean}
 */
export default function isFeatureEnabled(state, id) {
  return get(state, ['featureFlags', 'items', id, 'isEnabled'], false);
}
